import {
  SubscriptionPlan,
} from '@gymcloud/core';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

type Props = {
  isActive?: boolean,
  isCanceled?: boolean,
  isSelected?: boolean,
  isFree?: boolean,
  plan: SubscriptionPlan,
  onClick?: { (): void },
  onMore?: { (): void },
};

const PlanItem = ({
  plan,
  isActive,
  isCanceled,
  isSelected,
  isFree,
  onClick,
  onMore,
}: Props) => (
  <S.Container
    isActive={isActive}
    isSelected={isSelected}
    onClick={() => {
      if (!isActive) onClick?.()
    }}
  >
    <Flex align="center" spacing={15}>
      <Flex width="28px" height="28px">
        <S.CircleIcon
          isActive={isActive}
          isSelected={isSelected}
        />
      </Flex>
      <Text
        size="24px"
        color="#343A3D"
        lineHeight="24px"
      >
        {plan.name || 'Free Trial'}
      </Text>
    </Flex>

    <Flex width="250px" align="center" justify="flex-end">
      <Flex width="130px" align="center" justify="flex-end">
        {isFree ? (
          <Text
            size="24px"
            color="#333333"
            weight="600"
          >
            FREE
          </Text>
        ) : (
          <Text
            size="18px"
            color="#333333"
          >
            <Text size="24px" weight="600">
              ${parseFloat(plan.price).toFixed(2)}
            </Text>
            {`/${plan.interval === 'year' ? 'yr' : 'mo'}`}
          </Text>
        )}
      </Flex>
      <Flex width="120px" align="center" justify="flex-end">
        {isCanceled && (
          <S.Status status="canceled">
            Canceled
          </S.Status>
        )}

        {isActive && (
          <S.Status status="active">
            Active
          </S.Status>
        )}

        {!isCanceled && !isActive && (
          <S.PlanItemButton
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onMore?.()
            }}
          >
            Learn more
          </S.PlanItemButton>
        )}
      </Flex>
    </Flex>
  </S.Container>
);

export default PlanItem;
